import React from 'react';
import { Text, Link } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';

const DetailBox = (props) => {
  return (
    <div className="container">
      <div className="deatilHeader">
        <div className="row align-bottom">
          <div className="col-md-9">
            <h2>
              <Text field={props?.fields?.heading} />
            </h2>
            <p>
              <Text field={props?.fields?.text} />
            </p>
          </div>
          <div className="col-md-3">
            <div className="allDealButton">
              {props?.fields?.link?.value?.text && (
                <Link link={props?.fields?.link} variant="contained" color="secondary">
                  {props?.fields?.link?.value?.text}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DetailBox;
